"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesLayout = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "title", type: "string", description: "Title that will appear in AppBar." }),
    React.createElement(common_1.Property, { name: "drawerItems", type: "arrayOf(element)", description: "Array of React elements. Can be what you want, but to fits right, you muts use DrawerItem or DrawerSubitemsContainer elements." }))); };
exports.PropertiesLayout.displayName = 'PropertiesLayout';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentLayoutPage/PropertiesLayout.tsx
// module id = 692
// module chunks = 0